import { CLAIMSSTATEINTERFACE } from "@fitness-force/models";

export const CLAIMS_STATE = {};